import { render, staticRenderFns } from "./bmShopsSelector.vue?vue&type=template&id=51d86640&scoped=true&"
import script from "./bmShopsSelector.vue?vue&type=script&lang=js&"
export * from "./bmShopsSelector.vue?vue&type=script&lang=js&"
import style0 from "./bmShopsSelector.vue?vue&type=style&index=0&id=51d86640&prod&scoped=true&lang=scss&"
import style1 from "./bmShopsSelector.vue?vue&type=style&index=1&id=51d86640&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d86640",
  null
  
)

export default component.exports